export const MIN_DATE = new Date(1997, 0, 1);
export const SELECT_ALL_LIMIT = 100;
export const CASH_POSITIONS = {
  AGGREGATE_VALUES: ["Abbreviated Name (Fund)", "SMF Id (Fund)"],
  USER_ALERT: `Fund level ROA is calculated with the effect of Implied Cash (Prior Day NAV + any fund inflows - Current Day Exposure).
              In the case where Prior Day NAV is unavailable, ROA is instead calculated based on Exposure.`
}